import get from 'lodash/get';
import defaultFields from 'store/Host/contextFields';

export const selectFields = (state) => {
  const storedFields = get(state, 'preferences.host_table', defaultFields);
  const excludedFields = ['workspace_name'];
  const fields = {};

  Object.keys(defaultFields).forEach((field) => {
    if (!excludedFields.includes(field)) {
      fields[field] = {
        ...defaultFields[field],
        ...get(storedFields, field, {})
      };
    }
  });

  return fields;
};

export const selectHostList = (state) => get(state, 'host.hostList', []);
